"use strict";
exports.__esModule = true;
exports.HEREMapContext = void 0;
var react_1 = require("react");
exports.HEREMapContext = (0, react_1.createContext)({
    addToMarkerGroup: function () { return undefined; },
    removeFromMarkerGroup: function () { return undefined; }
});
